import { render, staticRenderFns } from "./NRWBetriebsbeschreibungLandw.vue?vue&type=template&id=6a27117c&"
import script from "./NRWBetriebsbeschreibungLandw.vue?vue&type=script&lang=js&"
export * from "./NRWBetriebsbeschreibungLandw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports